import { LeaderboardEntry, MatsnetLeaderboardEntry } from "@mezo/api"
import { Block, Skeleton, useStyletron } from "@mezo-org/mezo-clay"

import { LEADERBOARD_FETCH_CHUNK } from "#/shared/constants"

import LeaderboardHeader from "./LeaderboardHeader"
import LeaderboardItem from "./LeaderboardItem"

type LeaderboardContentProps = {
  currentUserRank: number | null
  leaderboard: (LeaderboardEntry | MatsnetLeaderboardEntry)[]
  isMatsLeaderboard: boolean
}

export default function LeaderboardContent({
  currentUserRank,
  leaderboard,
  isMatsLeaderboard,
}: LeaderboardContentProps) {
  const [css, theme] = useStyletron()

  return (
    <>
      <LeaderboardHeader isMatsLeaderboard={isMatsLeaderboard} />
      <Block
        overflow="hidden"
        className={css({ borderRadius: theme.borders.radius400 })}
      >
        {leaderboard.length > 0
          ? leaderboard.map((entry, index) => (
              <LeaderboardItem
                key={entry.address}
                address={entry.address}
                score={entry.score}
                username={entry.username}
                rank={index + 1}
                isCurrentUser={currentUserRank === index + 1}
                showPositionChange={!isMatsLeaderboard}
                positionChange={
                  "positionChange" in entry ? entry.positionChange : 0
                }
              />
            ))
          : Array.from({ length: LEADERBOARD_FETCH_CHUNK }, (_, index) => (
              <Skeleton
                key={`skeleton=${index}`}
                height="58px"
                overrides={{
                  Root: { style: () => ({ marginBottom: "2px" }) },
                }}
                animation
              />
            ))}
      </Block>
    </>
  )
}
